<template>
  <div class="join-form">
    <ul class="input-div">
      <li class="title">아이디</li>
      <li class="id-li">
        <input type="text" class="input-style" v-model="formData.id" @keyup="inputCheck('id')" placeholder="아이디를 입력하세요">
        <button class="id-check" @click="idCheckFunc">중복확인</button>
      </li>
      <li class="msg-li">
        <p v-if="!isEmpty(idCheckErr)" :class="{check: !idCheckErr, err: idCheckErr}">
          {{idCheckErr ? '사용 불가능한 아이디입니다.' : '사용 가능한 아이디입니다.'}}
        </p>
      </li>
    </ul>
    <ul class="input-div">
      <li class="title">비밀번호</li>
      <li>
        <input type="password" class="input-style" v-model="formData.pw" @keyup="inputCheck('pwd')" placeholder="비밀번호를 입력하세요">
      </li>
      <li class="msg-li">
        <p>비밀번호는 영어, 숫자, 특수문자 조합으로 9~16자리 가능합니다.</p>
        <p v-if="!isEmpty(pwdCondCheckErr)" :class="{err: !pwdCondCheckErr}">
          {{!pwdCondCheckErr ? '위 조건에 맞게 다시 입력해주세요.' : ''}}
        </p>
      </li>
    </ul>
    <ul class="input-div">
      <li class="title">비밀번호 재입력</li>
      <li>
        <input type="password" class="input-style" v-model="formData.repw" @keyup="inputCheck('pwd')" placeholder="비밀번호를 재 입력하세요">
      </li>
      <li class="msg-li">
        <p v-if="!isEmpty(pwdCheckErr)" :class="{check: !pwdCheckErr, err: pwdCheckErr}">
          {{pwdCheckErr ? '비밀번호가 불일치합니다. 다시 입력해주세요' : '비밀번호가 일치합니다.'}}
        </p>
      </li>
    </ul>
    <ul class="input-div">
      <li class="title">성명</li>
      <li>
        <input type="text" class="input-style" v-model="dinttData.name" disabled>
      </li>
    </ul>
    <ul class="input-div">
      <li class="title">생년월일</li>
      <li>
        <input type="text" class="input-style" v-model="dinttData.birth" disabled>
      </li>
    </ul>
    <ul class="input-div">
      <li class="title">성별</li>
      <li>
        <input type="text" class="input-style" v-model="dinttData.gender" disabled>
      </li>
    </ul>
    <!-- 휴대폰 인증일 경우 -->
    <ul v-if="certType === 'phone'" class="input-div">
      <li class="title">휴대폰번호</li>
      <li>
        <input type="text" class="input-style" v-model="dinttData.phone" disabled>
      </li>
    </ul>
    <!-- 아이핀 인증일 경우 -->
    <ul v-else class="input-div">
      <li class="title">휴대폰번호</li>
      <li class="id-li">
        <InputPhone v-model="dinttData.phone" :value="dinttData.phone" :label="'휴대폰번호를 입력하세요.'" @inputNum="inputCheck('phone')"/>
        <button class="id-check" @click="sendCode">인증코드 발송</button>
      </li>
      <li class="id-li pt">
        <input type="text" class="input-style" v-model="formData.authCode" placeholder="인증코드를 입력하세요.">
        <button class="id-check" @click="sendCodeCheck">인증코드 확인</button>
      </li>
    </ul>
    <!-- -->
    <ul class="input-div">
      <li class="title">이메일 주소</li>
      <li class="id-li">
        <input type="text" class="input-style" v-model="formData.email" @keyup="inputCheck('email')" placeholder="이메일 주소를 입력하세요">
        <button class="id-check" @click="emailCheckFunc">중복확인</button>
      </li>
      <li class="msg-li">
        <p v-if="!isEmpty(emailCheckErr)" :class="{check: !emailCheckErr, err: emailCheckErr}">
          {{emailCheckErr ? '사용할 수 없는 이메일입니다.' : '사용 가능한 이메일입니다.'}}
        </p>
      </li>
    </ul>
    <ul class="input-div">
      <li class="title">광고성 정보 수신 동의 안내</li>
      <li>
        <div class="text-area">
<pre>
회사는 다음과 같이 귀하의 개인정보를 수집 및 이용 합니다.

1. 개인정보의 수집 및 이용 목적
- 구단 소식 및 경기 정보 안내, 이벤트, 홍보, 프로모션 정보 등 전자적 전송매체를 이용한 광고성 정보 전송

2. 수집하는 개인정보의 항목
- 아이디, 회원명, 핸드폰번호

3. 개인정보의 보유 및 이용기간
- 수신 거부 혹은 회원 탈퇴시까지

4. 동의를 거부할 권 리 및 동의 거부시 불이익 사항
귀하는 본 개인정보의 수집 및 이용에 대한 동의를 거부할 권리가 있으며, 동의를 거부하더라도 별도의 불이익 사항은 없습니다.
</pre>
        </div>
      </li>
      <li class="info-agree">
        <input type="radio" name="allAgree" v-model="formData.adPush" :value="true" class="select-style">
        <label class="radio-label pr">동의</label>
        <input type="radio" name="allAgree" v-model="formData.adPush" :value="false" class="select-style" checked="checked">
        <label class="radio-label">미동의</label>
      </li>
    </ul>

    <div class="btn-div">
      <button class="login-btn" @click="joinFunc">회원가입</button>
      <button class="retry-btn" @click="retry">다시입력</button>
    </div>
  </div>
</template>

<script>
import {isEmail, isEmpty, trim, telHyphen, onlyNumber, expPhone, allTrim, isPwd} from '@/lib';
import InputPhone from '@/components/Common/InputPhone.vue';
import dayjs from 'dayjs';

export default {
  name: 'JoinForm',
  components: {InputPhone},
  data() {
    return {
      formData: {
        id: '',
        pw: '',
        repw: '',
        email: '',
        authCode: '',
        adPush: false
      },
      dinttData: {
        name: '',
        gender: '',
        phone: '',
        birth: '',
      },
      idCheck: false,
      idCheckErr: null,
      pwdCondCheckErr: null,
      pwdCheckErr: null,
      emailCheck: false,
      emailCheckErr: null,
      authCodeStatus: false, // 아이핀인증 인증코드 확인 여부
      certType: this.$store.getters['getCertType'],
      certInfo: this.$store.getters['getCertInfo'],
    }
  },
  mounted () {
    if(isEmpty(this.certInfo.success)) { // if(!this.certInfo) {
      alert('잘못된 접근입니다.');
      setTimeout(() => {
        return this.$router.push({name: 'join'});
      }, 0);
    }
    if(this.certInfo.exist === 'true') {
      alert('이미 가입된 회원입니다.');
      setTimeout(() => {
        return this.$router.push({name: 'login'});
      }, 0);
    }
    if(this.certInfo.agelimit === 'true') {
      alert('만 14세 미만은 가입할 수 없습니다.');
      setTimeout(() => {
        return this.$router.push({name: 'main'});
      }, 0);
    }

    this.dinttData.name = this.certInfo.name;
    this.dinttData.phone = telHyphen(this.certInfo.mobileno);
    this.dinttData.gender = this.certInfo.gender === 'F' ? '여성' : '남성';
    this.dinttData.birth = dayjs(this.certInfo.birth).format('YYYY-MM-DD');
    this.dinttData.ci = this.certInfo.ci;
    this.dinttData.di = this.certInfo.di;
    this.dinttData.realcheck_idx = this.certInfo.realcheck_idx;
    this.formData.adPush = this.$store.getters['getAdMsgAgree'];

  },
  methods: {
    isEmpty,
    isEmail,
    async idCheckFunc() {
      this.formData.id = allTrim(this.formData.id);
      if(isEmpty(this.formData.id)) {
        alert('아이디를 입력하세요.');
        return false;
      }

      const {data} = await this.$http.post('/account/check_id', {user_id: this.formData.id});
      if(data.success) {
        this.idCheck =  true;
        this.idCheckErr = false;
      } else {
        this.idCheck =  false;
        this.idCheckErr = true;
      }
      alert(data.message);
    },
    async emailCheckFunc() {
      this.formData.email = allTrim(this.formData.email);
      if(isEmpty(this.formData.email)) {
        alert('이메일을 입력하세요.');
        return false;
      }
      if(!isEmail(this.formData.email)) {
        alert('이메일 형식에 맞게 입력하세요.');
        return false;
      }

      const {data} = await this.$http.post('/account/check_email', {email: this.formData.email});
      if(data.success) {
        this.emailCheck =  true;
        this.emailCheckErr = false;
      } else {
        this.emailCheck =  false;
        this.emailCheckErr = true;
      }
      alert(data.message)
    },
    inputCheck(type) {
      if(type.includes('id')) {
        this.idCheck = false;
        this.idCheckErr = null;
      }
      if(type.includes('email')) {
        this.emailCheck = false;
        this.emailCheckErr = null;
      }
      if(type.includes('phone')) {
        this.authCodeStatus = false;
      }
      if(type.includes('pwd')) {
        this.pwdCondCheckErr = isPwd(this.formData.pw);

        this.pwdCheckErr = this.formData.pw !== this.formData.repw;
      }
    },
    async sendCode() {
      if(!expPhone(onlyNumber(this.dinttData.phone))) {
        alert('휴대폰 번호를 확인해주세요.');
        return false;
      }

      const {data} = await this.$http.post('/auth/sms/request',
          {mobileno: onlyNumber(this.dinttData.phone)});
      // console.log('인증코드 발송 res ==========>', data);
      if(data.success) {
        alert('인증코드가 발송되었습니다.');
      } else {
        alert('잠시 후 다시 시도해주세요.');
      }
    },
    async sendCodeCheck() {
      if(isEmpty(this.formData.authCode)) {
        alert('인증코드를 입력하세요.');
        return false;
      }

      const {data} = await this.$http.post('/auth/sms/check',
          {
            mobileno: onlyNumber(this.dinttData.phone),
            authCode: this.formData.authCode
          });
      // console.log('인증코드 확인 res ==========>', data);
      if(data.success) {
        alert('인증코드가 확인되었습니다.');
        this.authCodeStatus = true;
      } else {
        alert('인증코드가 일치하지 않습니다.');
        this.formData.authCode = '';
        this.authCodeStatus = false;
      }
    },
    async joinFunc() {
      if(!this.validityCheck()) {
        return false;
      }

      if(confirm('회원가입 하시겠습니까?')) {
        const body = {
          user_id: allTrim(this.formData.id),
          user_pw: allTrim(this.formData.pw),
          re_password: allTrim(this.formData.repw),
          email: allTrim(this.formData.email),
          name: trim(this.dinttData.name),
          mobileno: allTrim(this.dinttData.phone),
          cert_type: this.certType,
          ci: this.dinttData.ci,
          di: this.dinttData.di,
          birth: dayjs(this.dinttData.birth).format('YYYYMMDD'),
          gender: this.dinttData.gender === '여성' ? 'F' : 'M',
          agree_sms: this.formData.adPush ? 'Y' : 'N',
          realcheck_idx: this.dinttData.realcheck_idx
        }

        const {data} = await this.$http.post('/account/register', body);
        if(data.success) {
          alert('회원가입이 완료되었습니다.');
          if(data.message) {
            alert(data.message);
          }

          await this.$router.push({name: 'login'});
        } else {
          alert(data.message);
        }
      }
    },
    validityCheck() {
      if(isEmpty(this.formData.id)) {
        alert('아이디를 입력하세요.');
        return false;
      }
      if(!isEmpty(this.formData.id) && !this.idCheck) {
        alert('아이디 중복확인 하세요.');
        return false;
      }
      if(isEmpty(this.formData.pw) || isEmpty(this.formData.repw)) {
        alert('비빌번호를 입력하세요.');
        return false;
      }

      if(!isEmpty(this.formData.pw) && !isEmpty(this.formData.repw)) {
        if(this.formData.pw !== this.formData.repw) {
          alert('비빌번호가 일치하지 않습니다.');
          return false;
        }
      }
      if(this.certType === 'ipin' && !this.authCodeStatus) { // 아이핀 인증일 경우
        alert('휴대폰 인증이 필요합니다.');
        return false;
      }
      if(isEmpty(this.formData.email)) {
        alert('이메일을 입력하세요.');
        return false;
      }
      if(!expPhone(onlyNumber(this.dinttData.phone))) {
        alert('휴대폰 번호를 확인해주세요.');
        return false;
      }
      if(!isEmpty(this.formData.email) && !this.emailCheck) {
        alert('이메일 중복확인 하세요.');
        return false;
      }
      return true;
    },
    retry() {
      if(!confirm('다시 입력하시겠습니까?')) {
        return false;
      }

      this.formData = {};
      this.idCheck = false;
      this.idCheckErr = null;
      this.pwdCondCheckErr = null;
      this.pwdCheckErr = null;
      this.emailCheck = false;
      this.emailCheckErr = null;
    }
  }
}
</script>
